import address from './address'; 

export class FinanceEligibilityModule {

    constructor() {

        var MINIMUM_ADDRESS_HISTORY_YEARS = 3;

        /*
         * TODO - much of the below is generic bootstrapping code
         * and should be centralised where possible.
         */

        // Generic - initialise address
        var $addressForms = $(".address-form-wrapper");
        $addressForms.each(function () {
            var $addressForm = $(this);
            var $addressNotFound = $addressForm.find(".address-not-found");
            var $addressSection = $addressForm.find(".address-section");
            var $addressDropdown = $addressForm.find(".address-dropdown");
            var $fieldsWithValues = $addressSection.find(":not(.address-dropdown) :input").filter(function () { return $(this).val() !== ''; });

            $addressNotFound.hide();
            $addressDropdown.hide();
            
            if ($fieldsWithValues.length) {

            } else {
                $addressSection.hide();
            }

        });

        function sumPreviousYears($addressForm, $yearsAtAddress) {
            var $prevYears = $addressForm.prevAll(".address-form-wrapper").find(".years-at-address");
            var sumOfYears = 0;
            $yearsAtAddress.add($prevYears).each(function () {
                var currentVal = parseInt($(this).val(), 10);
                sumOfYears += (isNaN(currentVal) ? 0 : currentVal);
            });
            return sumOfYears;
        }

        function showHideNextYears($addressForm, $yearsAtAddress, $nextYears) {
            if ($yearsAtAddress.val()) {
                var sumOfYears = sumPreviousYears($addressForm, $yearsAtAddress);
                if (sumOfYears < MINIMUM_ADDRESS_HISTORY_YEARS) {
                    var $nextYear = $nextYears.first();
                    $nextYear.show();
                    $nextYear.find(".years-at-address").trigger("change");
                } else {
                    $nextYears.hide();
                }
            }
        }

        // Non-generic
        $addressForms.each(function () {
            var $addressForm = $(this);
            var $yearsAtAddress = $addressForm.find(".years-at-address");
            var $nextYears = $addressForm.nextAll(".address-form-wrapper");
            $yearsAtAddress.on('change', function () {
                showHideNextYears($addressForm, $yearsAtAddress, $nextYears);
            });
        });

        var $firstAddress = $addressForms.first();
        var $firstYearsAtAddress = $firstAddress.find(".years-at-address");
        $firstYearsAtAddress.trigger("change");

        address();

        // Initialise validator
        $.validator.setDefaults({
            highlight: function(element) {
                $(element)
                    .closest(".element-container")
                    .addClass("container-error")
                    .parents(".element-group")
                    .show();
            },
            unhighlight: function(element) {
              $(element)
                .closest(".element-container")
                .removeClass("container-error");
            },
            submitHandler: function (form) {
                var $submitButtons = $(form).find(":input.disable-on-submit");
                var $submitContainers = $submitButtons.closest(".element-container");
                $submitButtons.prop('disabled', true);
                $submitContainers.addClass("submitting");
                form.submit();
            },
            ignore: [":input[type='hidden']"]
        });

        // Find server-side validated elements in error
        $(":input.input-validation-error").each(function() {
            $(this).closest(".element-container")
                .addClass("container-error")
                .parents(".element-group")
                .show();
        });

        // extend jquery range validator to work for required checkboxes (https://dotnetfiddle.net/JbPh0X)
        var defaultRangeValidator = $.validator.methods.range;
        $.validator.methods.range = function(value, element, param) {
            if(element.type === 'checkbox') {
                // if it's a checkbox return true if it is checked
                return element.checked;
            } else {
                // otherwise run the default validation function
                return defaultRangeValidator.call(this, value, element, param);
            }
        }

        // Sanitise values to only include digits, particularly useful for removing commas etc (which don't play nicely with MVC)
        $("input[data-val-number][type!='hidden']").on("input", function() {

            var $input = $(this);
            var nonDigitRegex = /[^\d]/gi;
            var strCurrentVal = $input.val();
            var strSanitisedVal = strCurrentVal.replace(nonDigitRegex, '');
            $input.val(strSanitisedVal);
        });

        $(":input[data-val-required]").each(function() {
            $(this).closest(".element-container").addClass("required-field");
        });       
        
        jQuery.validator.addMethod(
            "threeFieldDateOfBirth",
            function (value, element, params) {
                //debugger;
                var $day = $(element);
                var $month = params.month;
                var $year = params.year;
              
                return !$day.is(":blank") && !$month.is(":blank") && !$year.is(":blank");
            },
            "Please complete this information"
        );

        var $threeFieldDateOfBirth = $(".finance-eligibility .dob-editor");
        var $day = $threeFieldDateOfBirth.find(".day");
        var $month = $threeFieldDateOfBirth.find(".month");
        var $year = $threeFieldDateOfBirth.find(".year");
        $month.add($year).on('change',function() {
            $day.valid();
        });        

        $(document).ready(function() {       
            $day.rules("add", {
                threeFieldDateOfBirth: {
                    month: $month,
                    year: $year
                }
            });
        });


        this.init();
    }

    init() {

        var RESIDENTIAL_STATUS_OWNER = "Owner";

        var EMPLOYMENT_STATUS_SELF_EMPLOYED = "Self-employed";
        var EMPLOYMENT_STATUS_EMPLOYED = "Employed";
        var EMPLOYMENT_STATUS_NOT_EMPLOYED = "Not-employed";

        var that = this;

        var $financeEligibility = $(".finance-eligibility");
        var $monthlyRentAmount = $financeEligibility.find(".monthly-rent-amount");
        var $residentialStatusSelect = $financeEligibility.find(".residential-status select");
        var $selfEmployedGroup = $financeEligibility.find(".self-employed-group");
        var $employedGroup = $financeEligibility.find(".employed-group");
        var $notEmployedGroup = $financeEligibility.find(".not-employed-group");
        var $employmentStatusSelect = $financeEligibility.find(".employment-status select");
        var $allEmploymentFields = $selfEmployedGroup.add($employedGroup).add($notEmployedGroup);

        $residentialStatusSelect.on('change',function () {
            var strSelectedVal = $(this).val();
            if (strSelectedVal && strSelectedVal !== RESIDENTIAL_STATUS_OWNER) {
                $monthlyRentAmount.show();
            } else {
                $monthlyRentAmount.hide();
            }
        });

        $residentialStatusSelect.trigger("change");

        $employmentStatusSelect.on('change',function () {
            var strSelectedVal = $(this).val();
            if (strSelectedVal === EMPLOYMENT_STATUS_SELF_EMPLOYED) {
                $allEmploymentFields.not($selfEmployedGroup).hide();
                $selfEmployedGroup.show();
            } else if (strSelectedVal === EMPLOYMENT_STATUS_EMPLOYED) {
                $allEmploymentFields.not($employedGroup).hide();
                $employedGroup.show();
            } else if (strSelectedVal === EMPLOYMENT_STATUS_NOT_EMPLOYED) {
                $allEmploymentFields.not($notEmployedGroup).hide();
                $notEmployedGroup.show();
            } else {
                $allEmploymentFields.hide();
            }
        });

        $employmentStatusSelect.trigger("change");

        // Show the form once initialised
        $financeEligibility.addClass("js");
    }

}
